import { rootActions } from "../reducers/root.slice";
import { put, select } from "typed-redux-saga";
import { selectRootState } from "../selectors";
import { setStatus } from "../dom-utils";
import RowUtils from "../utils/RowUtils";

function* findClickedPoint(
  action: ReturnType<typeof rootActions.findClickedPoint>
) {
  try {
    const { rows, leftPanel } = yield* select(selectRootState);
    const { selectedDataset } = leftPanel;

    if (!selectedDataset) {
      setStatus("No dataset selected");
      return;
    }

    const row = rows.find((row) => RowUtils.getId(row) === action.payload);

    if (!row) {
      setStatus("No data row found for clicked point");
      console.error("No data row found for clicked point", action.payload);
      return;
    }

    yield* put(rootActions.setClickedPoint(row));
  } catch (error) {
    setStatus("Error finding clicked point");
    console.error(error);
  }
}

export default findClickedPoint;
